import { render, staticRenderFns } from "./AwardVehiclesField.vue?vue&type=template&id=0ed523fc"
import script from "./AwardVehiclesField.vue?vue&type=script&lang=js"
export * from "./AwardVehiclesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports